var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMiPerfil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_mi_perfil",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.18,
    height: 28.18,
    viewBox: "0 0 28.18 28.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M0,0H28.18V28.18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M13.393,16.264v2.348a7.045,7.045,0,0,0-7.045,7.045H4a9.393,9.393,0,0,1,9.393-9.393Zm0-1.174a7.045,7.045,0,1,1,7.045-7.045A7.043,7.043,0,0,1,13.393,15.09Zm0-2.348a4.7,4.7,0,1,0-4.7-4.7A4.7,4.7,0,0,0,13.393,12.741Zm3.047,9.172a4.121,4.121,0,0,1,0-1.906l-1.165-.673L16.449,17.3l1.165.673a4.1,4.1,0,0,1,1.65-.953V15.677h2.348v1.344a4.1,4.1,0,0,1,1.65.953l1.165-.673L25.6,19.335l-1.165.673a4.121,4.121,0,0,1,0,1.9l1.165.673-1.174,2.034-1.165-.673a4.1,4.1,0,0,1-1.65.953v1.344H19.264V24.9a4.1,4.1,0,0,1-1.65-.953l-1.165.673-1.174-2.034,1.165-.672Zm4,.808a1.761,1.761,0,1,0-1.761-1.761A1.761,1.761,0,0,0,20.438,22.722Z",
    transform: "translate(0.697 0.174)",
    fill: "#efefef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMiPerfil);
export default __webpack_public_path__ + "static/media/sidebar_mi_perfil.113425e13f835923e378bcb7507bb916.svg";
export { ForwardRef as ReactComponent };